import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=ef853e7e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef853e7e')) {
      api.createRecord('ef853e7e', component.options)
    } else {
      api.reload('ef853e7e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=ef853e7e&", function () {
      api.rerender('ef853e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2S7gYuOmnT64N/JS/imageCarousel.vue"
export default component.exports